// Author YuJiaBei
// Date 2022-01-25 16:25:44

import * as model from "@/model/em/inspection/InspectionRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
        callbackApi: process.env.VUE_APP_EM_INSPECTION_URL + '/inspectionRecord/workflow/complete-feedback',
        processDefinitionKey: "em_inspection_record",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
